import PropTypes from 'prop-types';
import React, { useState } from 'react';

import TourDetails from './TourDetails';
import AddEvents from './AddEvents';
import TourDateForm from './TourDateForm';
import AnnounceAndOnSale from './AnnounceAndOnSale';
import EventImages from './EventImages';

import Popup from "reactjs-popup";

import {
  TOUR_DETAILS_MENU_ITEM,
  EVENTS_MENU_ITEM,
  ANNOUNCE_AND_ON_SALE_ITEM,
  EVENT_IMAGES_MENU_ITEM
} from '../constants/editTourConstants';

import {
  utcToTimeZone
} from '../../../shared/timeZoneLogic';

const popupContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "245px",
  "padding": "0px"
}

const axios = require('axios').default;
import { ToastContainer, toast } from 'react-toastify';

const EditTour = ({
  csrfToken,
  team,
  currentUser,
  tour,
  tourChanged,
  tourDates,
  tourDatesChanged
}) => {
  const [activeTab, setActiveTab] = useState(TOUR_DETAILS_MENU_ITEM);
  const [tourDate, setTourDate] = useState(null);

  const fetchTourDate = (tourDateId) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.get(`/teams/${team.id}/tours/${tour.id}/tour_dates/${tourDateId}`)
      .then(({data}) => {
        gon.timeZone = data.tzinfo_identifier;

        const [year, month, day] = data.event_on_for_frontend.split('-').map(Number);
        const adjustedEventOn = new Date(year, month - 1, day);

        setTourDate({
          ...data,
          id: tourDateId,
          event_on: adjustedEventOn,
          announce_at: utcToTimeZone(data.announce_at, data.tzinfo_identifier),
          presale_start_at: utcToTimeZone(data.presale_start_at, data.tzinfo_identifier),
          presale_end_at: utcToTimeZone(data.presale_end_at, data.tzinfo_identifier),
          public_on_sale_start_at: utcToTimeZone(data.public_on_sale_start_at, data.tzinfo_identifier),
          public_on_sale_end_at: utcToTimeZone(data.public_on_sale_end_at, data.tzinfo_identifier),
          vip_start_at: utcToTimeZone(data.vip_start_at, data.tzinfo_identifier),
          vip_end_at: utcToTimeZone(data.vip_end_at, data.tzinfo_identifier)
        });

        setActiveTab(EVENTS_MENU_ITEM);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const deleteTourDate = (tourDate) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.delete(`/teams/${team.id}/tours/${tour.id}/tour_dates/${tourDate.id}`)
      .then(() => {
        var updated = tourDates.filter(td => td.id !== tourDate.id);
        tourDatesChanged(updated);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  return (
    <div>
      <ToastContainer icon={false} />
      <div className="form-row">
        <div className="col-12 col-md">
          <div className="card"
                style={{
                  border: "1px solid #E9EAEB"
                }}>
            <div className='card-body' style={{padding: '15px'}}>
              <div className="row">
                <div className="col-12 col-lg-auto" style={{width: '230px', marginBottom: '20px'}}>
                  <ul className="list-group list-group-flush list-group-light">
                    <li className={"list-group-item rounded " + (activeTab === TOUR_DETAILS_MENU_ITEM ? 'active' : '')}
                        style={{"padding": "8px 12px"}}>
                      <a href="#"
                          className="stretched-link"
                          onClick={
                            (e) => {
                              e.preventDefault();
                              setActiveTab(TOUR_DETAILS_MENU_ITEM);
                            }
                          }>
                        Tour details
                      </a>
                    </li>
                    <li className={"list-group-item rounded " + (activeTab === EVENTS_MENU_ITEM ? 'active' : '')}
                        style={{"padding": "8px 12px", "position": "relative"}}>
                      <a href="#"
                          className={"stretched-link " + (!tour.id ? 'disabled' : '')}
                          onClick={
                            (e) => {
                              e.preventDefault();

                              if (tour.id) {
                                setActiveTab(EVENTS_MENU_ITEM);
                                setTourDate(null);
                              }
                            }
                          }>
                        Events
                      </a>
                      {tourDates.length > 0 && (
                        <span style={{
                          position: 'absolute',
                          left: '64px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: '#FAFAFA',
                          color: '#414651',
                          borderRadius: (tourDates.length < 10 ? '50%' : '10px'),
                          padding: '2px 8px',
                          fontSize: '12px',
                          textAlign: 'center',
                          border: "1px solid #E9EAEB",
                          pointerEvents: 'none'
                        }}>
                          {tourDates.length}
                        </span>
                      )}
                    </li>
                    <li className={"list-group-item rounded " + (activeTab === ANNOUNCE_AND_ON_SALE_ITEM ? 'active' : '')}
                        style={{"padding": "8px 12px"}}>
                      <a href="#"
                          className={"stretched-link " + (!tour.id ? 'disabled' : '')}
                          onClick={
                            (e) => {
                              e.preventDefault();

                              if (tour.id) {
                                setActiveTab(ANNOUNCE_AND_ON_SALE_ITEM);
                              }
                            }
                          }>
                        Announce & On-Sale
                      </a>
                    </li>
                    <li className={"list-group-item rounded " + (activeTab === EVENT_IMAGES_MENU_ITEM ? 'active' : '')}
                        style={{"padding": "8px 12px"}}>
                      <a href="#"
                          className={"stretched-link " + (!tour.id ? 'disabled' : '')}
                          onClick={
                            (e) => {
                              e.preventDefault();

                              if (tour.id) {
                                setActiveTab(EVENT_IMAGES_MENU_ITEM);
                              }
                            }
                          }>
                        Event Images
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-lg">
                  <div className="row">
                    <div className="col-12">
                      {activeTab === TOUR_DETAILS_MENU_ITEM ? (
                        <TourDetails
                          csrfToken={csrfToken}
                          team={team}
                          currentUser={currentUser}
                          tour={tour}
                          tourChanged={tourChanged}
                          setActiveTab={setActiveTab}
                        />
                      ) : activeTab === EVENT_IMAGES_MENU_ITEM ? (
                        <EventImages
                          csrfToken={csrfToken}
                          team={team}
                          tour={tour}
                          tourChanged={tourChanged}
                        />
                      ) : activeTab === ANNOUNCE_AND_ON_SALE_ITEM ? (
                        <AnnounceAndOnSale
                          csrfToken={csrfToken}
                          team={team}
                          tour={tour}
                          tourChanged={tourChanged}
                        />
                      ) : (
                        tourDate === null ? (
                          <AddEvents
                            csrfToken={csrfToken}
                            team={team}
                            tour={tour}
                            currentUser={currentUser}
                            setTourDate={setTourDate}
                          />
                        ) : (
                          <TourDateForm
                            csrfToken={csrfToken}
                            team={team}
                            currentUser={currentUser}
                            tour={tour}
                            tourDate={tourDate}
                            tourDates={tourDates}
                            tourDatesChanged={tourDatesChanged}
                            deleteTourDate={deleteTourDate}
                            setTourDate={setTourDate}
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-auto">
          <div className="tour-dates-column">
            {tourDates.length > 0 ? (
              <div className="card mb-4 mb-md-0"
                    style={{border: "1px solid #E9EAEB"}}>
                {tour.name && tour.name.length > 0 ? (
                  <div className="card-header bg-white"
                        style={{
                          padding: '20px 24px',
                          borderBottom: '1px solid #E9EAEB'
                        }}>
                    <p className='mb-0 text-truncate'
                        style={{fontSize: '16px', fontWeight: '600'}}>
                      {tour.name}
                    </p>
                  </div>
                ) : null}
                <div className="card-body">
                  {tourDates
                    .sort((a, b) => new Date(a.event_on) - new Date(b.event_on))
                    .map((partialTourDate, index) => (
                      <div key={index}
                          style={{marginBottom: '16px'}}
                          className="d-flex align-items-center justify-content-between position-relative">
                        <div className="w-75 overflow-hidden">
                          <a href="#"
                              className="mb-0 text-muted text-truncate d-block"
                              title={partialTourDate.venue_name_city_state}
                              onClick={
                                (e) => {
                                  e.preventDefault();
                                  fetchTourDate(partialTourDate.id);
                                }
                              }>
                            {partialTourDate.venue_name_city_state}
                          </a>
                          <p className="mb-0 text-muted">
                            {partialTourDate.event_on}
                          </p>
                        </div>
                        <div>
                          <Popup arrow={false}
                                 offsetY={5}
                                 position="bottom right"
                                 contentStyle={popupContentStyle}
                                 onOpen={
                                   (e) => {
                                     e.preventDefault();
                                   }
                                 }
                                 trigger={open => (
                                   <a href="#"
                                      className="text-muted">
                                     <i className="fas fa-ellipsis-v"></i>
                                   </a>
                                 )} >
                            {close => (
                              <div className='row text-left'>
                                <div className="col-12">
                                  <ul className="list-group offer-inline-menu highlight-primary">
                                    <li className="list-group-item rounded-0"
                                        style={{padding: "15px 15px 12px 15px"}}>
                                      <a href="#"
                                          onClick={
                                            (e) => {
                                              e.preventDefault();
                                              fetchTourDate(partialTourDate.id);
                                              close();
                                            }
                                          }
                                          className="text-dark">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-pencil"></i>
                                        </span>
                                        Edit event
                                      </a>
                                    </li>
                                    <li className="list-group-item rounded-0"
                                        style={{padding: "15px 15px 12px 15px"}}>
                                      <a href="#"
                                          onClick={
                                            (e) => {
                                              e.preventDefault();

                                              if(!window.confirm("Are you sure you want to delete this event?")) {
                                                return;
                                              }

                                              deleteTourDate(partialTourDate);

                                              if(tourDate && tourDate.id === partialTourDate.id) {
                                                setTourDate(null);
                                              }

                                              close();
                                            }
                                          }
                                          className="text-dark">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-trash"></i>
                                        </span>
                                        Delete event
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </Popup>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
};

EditTour.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  tour: PropTypes.object.isRequired,
  tourChanged: PropTypes.func.isRequired,
  tourDates: PropTypes.array,
  tourDatesChanged: PropTypes.func.isRequired
};

export default EditTour;
